import React from "react"
import theme from "../../../config/theme"
import Icon from "react-icons-kit"
import { chevronRight } from "react-icons-kit/feather"
import { chevronLeft } from "react-icons-kit/feather"
import Head from "next/head"

const generatePages = (pages, currentPage) => {
    let pageList = [];
    pages = parseInt(pages);
    currentPage = parseInt(currentPage);

    for(let i = 1; i <= pages - 1; i++) {
        if( pages <= 7 || 
            (currentPage < 5 && i <= 5) || 
            (currentPage > pages - 5 && i > pages - 5) ||
            (i === 1) ||
            [i, i-1, i+1].indexOf(currentPage) !== -1
        ) {
            pageList.push(i);
        } else {
            if(pageList[pageList.length - 1] !== '...') {
                pageList.push('...');
            }
        }
    }

    pageList.push(pages);
    

    return pageList;
}

const Pagination = (props) => {
    const pageCount = Math.ceil(props.pagination.total / props.pagination.pageSize)

    
    const changePage = (page, disabled = false) => {
        if(disabled) {
            return;
        }

        props.onPageChange(page);
    }
    
    let paginationPage = parseInt(props.paginationPage);

    return (
        <div className="pagination-wrapper">
            <style jsx>{`
                .pagination-wrapper {
                    display: flex;
                    margin-top: 20px;
                    justify-content: center;
                }

                .summary {
                    flex-grow: 1;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                }

                @media only screen and (max-width: 1000px) {
                    .pagination-wrapper {
                        flex-direction: column;
                    }

                    .summary {
                        justify-content: center;
                    }
                }

                .pages {
                    display: flex;
                    justify-content: center;
                }

                .page {
                    height: 32px;
                    min-width: 32px;
                    padding: 5px;
                    margin: 5px;
                    background-color: ${theme.colors.base.white};
                    color: ${theme.colors.base.black};
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-weight: 700;
                    box-shadow: 3px 3px 0px rgba(0, 0, 0, 0.1);
                    cursor: pointer;
                    transition: all 0.1s ease-in;
                    user-select: none;

                }

                .page.current, .page:hover {
                    background-color: ${theme.colors.base.secondary};
                    color: ${theme.colors.base.white};
                }

                .page.disabled {
                    background-color: ${theme.colors.base.darkGray};
                    color: ${theme.colors.base.white};
                    cursor: not-allowed;
                }



            `}</style>
            <Head>
                ${parseInt(props.pagination.page) > 1 ?
                    <link rel="prev" href={props.prevPage} /> : null}

                ${props.pagination.page < pageCount && pageCount > 1 ?
                    <link rel="next" href={props.nextPage} /> : null}
            </Head>
            <div className="hide-lt-m">
                <div className="summary">
                    <strong>{((props.pagination.page - 1) * props.pagination.pageSize + 1)}</strong>  &nbsp; - &nbsp; 
                    <strong>{Math.min(((props.pagination.page) * props.pagination.pageSize), props.pagination.total)}</strong> &nbsp; din &nbsp;
                    <strong>{props.pagination.total}</strong> &nbsp; 
                    {props.pagination.total > 19 ? 'de' : ''} produse
                </div>
                <div className="pages">
                    <div onClick={() => { changePage(parseInt(props.pagination.page) - 1, parseInt(props.pagination.page) === 1) }} className={`page ${parseInt(props.pagination.page) <= 1 ? 'disabled' : ''}`}>
                        <Icon size={24} icon={chevronLeft}/>
                    </div>
                    
                    {generatePages(pageCount, props.pagination.page).map((page, index) => (
                        <div key={`page-${page}-${index}`} onClick={() => { changePage(page, page === '...') } } className={`page ${page === '...' ? 'disabled' : parseInt(props.pagination.page) === parseInt(page) ? 'current' : ''}`}>
                            {page}
                        </div>
                    ))}

                    <div onClick={() => { changePage(parseInt(props.pagination.page) + 1, parseInt(props.pagination.page) === pageCount || pageCount <= 1); }} 
                        className={`page ${props.pagination.page === pageCount || pageCount <= 1 ? 'disabled' : ''}`}>
                        <Icon size={24} icon={chevronRight}/>
                    </div>
                </div>
            </div>
            <div className="hide-gt-m">
                <div className="pages">
                    <div className={`page ${parseInt(props.pagination.page) <= 1 ? 'disabled' : ''}`} onClick={() => { changePage(parseInt(props.pagination.page)- 1, parseInt(props.pagination.page) === 1) }}>
                        <Icon size={24} icon={chevronLeft}/>
                    </div>
                    <div className="page current">
                        Pagina {props.pagination.page} din {Math.ceil(props.pagination.total/props.pagination.pageSize)}
                    </div>
                    <div className={`page ${parseInt(props.pagination.page) >= pageCount || pageCount <= 1 ? 'disabled' : ''}`}  
                    onClick={() => { changePage(parseInt(props.pagination.page)+ 1, parseInt(props.pagination.page) === pageCount || pageCount <= 1); }} >
                        <Icon size={24} icon={chevronRight}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Pagination;